import * as angular from 'angular';
import { Config } from '@/utils/Config';
import { Consoler } from '@/utils/Consoler';
import { i18n } from '@/i18n';
import { angularAlexMapDirective } from './directive/angular-alex-map.directive';

const appName = 'MemberContactsMapApp';

class AngularAlexMapDefinition {

    private localizations = {
        controlTitles: {
            layers: this.translate('alexMap.controlTitles.layers'),
            fullscreen: this.translate('alexMap.controlTitles.fullscreen'),
            quitFullscreen: this.translate('alexMap.controlTitles.quitFullscreen'),
            showLegend: this.translate('alexMap.controlTitles.showLegend')
        },
        mapLayers: {
            extweb_karta: this.translate('alexMap.mapLayers.extweb_karta'),
            // extweb_vo: this.translate('alexMap.mapLayers.extweb_vo'),
            extweb_sbo: this.translate('alexMap.mapLayers.extweb_sbo')
        }
    };

    createAngularApp() {
        Consoler.debugWarn('Creating angular app for alex map. Angular.version:', angular.version);

        angular.module(appName, ['alex']);   

        angular
            .module(appName)
            .config(['alConfigProvider', '$sceDelegateProvider', alConfig]);

        function alConfig(alConfigProvider, $sceDelegateProvider) {            
            alConfigProvider.gisServicesUrl = Config.Settings.ApiBaseUrl + '/' + Config.GisServicesServicesUrl;
            $sceDelegateProvider.resourceUrlWhitelist(['self', Config.Settings.ApiBaseUrl + '**']);
            alConfigProvider.appGuid = null;
        }

        angular.module(appName)
            .constant('localizations', this.localizations);
        
        angular
            .module(appName)
            .directive('angularAlexMap', [
                'localizations',
                'alConfig',
                angularAlexMapDirective
            ]);
    }
    
    private translate(key, values?: any[]) {
        return i18n.t(key, values).toString();
    }
}

export const AngularAlexMap = new AngularAlexMapDefinition();

export {
    appName
}
